import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import {CellType} from '@grapecity/wijmo.grid';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
// import {renderTextField, renderSelect} from '../../../atoms/CustomPart.js';
import {renderSelect} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
// import DangerButton from '../../..//atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
// import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
// import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TK_INVESTIGATION_TOTAL_LIST.name, href: ''},
];


const styles = (theme) => ({
  button: {
    margin: '15px 10px 5px 10px',
  },
  wave: {
    // fontSize: '1.2em',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
  fields: {
    'margin': '0px 10px 15px 10px',
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '100px',
  },
  tabPanel: {
    padding: 0,
  },
});

// 調査口数一覧
const populationViews = [
  {binding: 'chousaYear', header: '次回調査年度', type: 'text', width: 80, readOnly: true},
  {binding: 'zigyoujo', header: '旧NW事業所', type: 'text', width: 105, readOnly: true},

  {binding: 'chousaCompany', header: '委託エリア', type: 'text', width: 90, readOnly: true},
  {header: '４年周期', dataType: 'header', elems: [
    {binding: 'fourYear01', header: '従量電灯等', dataType: 'Number', width: 90, readOnly: true},
    {binding: 'fourYear02', header: '時間帯別電灯等', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'fourYear03', header: '定額・街灯Ａ(口数)', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'fourYear04', header: '定額(口数)(再掲)', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'fourYear05', header: '街灯Ａ(口数)(再掲)', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'fourYear06', header: '街灯Ａ(灯個)(再掲)', dataType: 'Number', width: 90, readOnly: false},
  ]},

  {header: '毎年調査', dataType: 'header', elems: [
    {binding: 'chousaIndustry2', header: '寝老人', dataType: 'Number', width: 90, readOnly: true},
    {binding: 'chousaIndustry3', header: 'プール', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'chousaIndustry4', header: '公衆浴場', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'chousaIndustry5', header: '学校・プール', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'chousaIndustry6', header: '病院等', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'chousaIndustry7', header: '老人福祉施設', dataType: 'Number', width: 90, readOnly: false},
    {binding: 'chousaIndustry8', header: '重要文化財', dataType: 'Number', width: 90, readOnly: false},
  ]},
  {binding: 'souKei', header: '合計', dataType: 'Number', width: 90, readOnly: false},
  {binding: 'jrTs', header: 'ＪＲ調査(再掲)', dataType: 'Number', width: 90, readOnly: false},
  {binding: 'lastYear', header: '前年度繰越(再掲)', dataType: 'Number', width: 90, readOnly: false},
];

// 可否判定申込で使用する申込ステータスコード
// 作成中,可否判定受付中,強度計算中,可否判定中,可否判定済,本申込中,完結（期限切れ）,完結（取止め）,完結（申込済）
// const proprietyOrderStatus = ['00', '01', '02', '03', '04', '05', '91', '92', '93'];

/**
 * 調査理由入力票一覧画面
 * 画面ID:SCB1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const data =[
      {chousaYear: '2025', chousaCompany: '委託１', zigyoujo: '山陰', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '出雲', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '隠岐', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田（益田）', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: ' 小計', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

      {chousaYear: '2025', chousaCompany: '２・３', zigyoujo: '山陰', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '出雲', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '隠岐', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田（益田）', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: ' 小計', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

      {chousaYear: '2026', chousaCompany: '委託１', zigyoujo: '山陰', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '出雲', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '隠岐', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田（益田）', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: ' 小計', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

      {chousaYear: '2026', chousaCompany: '２・３', zigyoujo: '山陰', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '出雲', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '隠岐', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田（益田）', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: ' 小計', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

      {chousaYear: '2027', chousaCompany: '委託１', zigyoujo: '山陰', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '出雲', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '隠岐', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田（益田）', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: ' 小計', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

      {chousaYear: '2027', chousaCompany: '２・３', zigyoujo: '山陰', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '出雲', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '隠岐', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田（益田）', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: ' 小計', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

      {chousaYear: '2028', chousaCompany: '委託１', zigyoujo: '山陰', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '出雲', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '隠岐', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田（益田）', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: ' 小計', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

      {chousaYear: '2028', chousaCompany: '２・３', zigyoujo: '山陰', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '出雲', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '隠岐', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: '浜田（益田）', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: ' ', chousaCompany: ' ', zigyoujo: ' 小計', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

      {chousaYear: '合計 ', chousaCompany: ' ', zigyoujo: ' 中電ＮＷ', fourYear01: '0', keiSyuOther: '0', fourYear02: '0', fourYear03: '0', fourYear04: '0', fourYear05: '0', fourYear06: '0', chousaIndustry2: '0', chousaIndustry3: '0', chousaIndustry4: '0', chousaIndustry5: '0', chousaIndustry6: '0', chousaIndustry7: '0', chousaIndustry8: '0', chousaIndustry9: '0', souKei: '0', jrTs: '0', lastYear: '0'},
      {chousaYear: '  ', chousaCompany: ' ', zigyoujo: '委託１ ', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: '  ', chousaCompany: ' ', zigyoujo: '２・３ ', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},
      {chousaYear: '  ', chousaCompany: ' ', zigyoujo: '合計 ', fourYear01: '100', keiSyuOther: '100', fourYear02: '100', fourYear03: '100', fourYear04: '100', fourYear05: '100', fourYear06: '100', chousaIndustry2: '1', chousaIndustry3: '1,100,100', chousaIndustry4: '200', chousaIndustry5: '30', chousaIndustry6: '400', chousaIndustry7: '500', chousaIndustry8: '12', chousaIndustry9: '22', souKei: '23,222', jrTs: '100', lastYear: '200'},

    ];

    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    // try {
    //   const result = await this._searchOrder();
    //   if (!result) {
    //     return;
    //   }
    //   // 検索結果が0件の場合、エラーダイアログ表示
    //   if (!this.props.hasOwnProperty('orderList') ||
    //     !this.props.orderList ||
    //     this.props.orderList.length <= 0 ) {
    //     this.props.doShowMessage({
    //       message: 'CE0016',
    //     });
    //   }
    // } catch (error) {
    //   this.props.doShowMessage({
    //     message: 'CS0001',
    //     action: () => {
    //       this.props.history.push('/login');
    //     },
    //   });
    // }
    // this.gridRef = {}
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'CS0001',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 表示ボタン押下時
   */
  doDisplayInfo = async () => {
    this.props.navigate(GMN_PATH.CUSTOMER_SECURITY_INFO);
  };

  /**
   * 帳票印刷
   */
  doPrint = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['調査口数一覧出力'],
      },
    });
  };


  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * セル結合をカスタム
   * @param {object} wjgGrid wijmo.grid モジュール
   * @param {object} panel 範囲を含むGridPanel
   * @param {number} r セルが含まれる行のインデックス
   * @param {number} c セルが含まれる列のインデックス
   * @param {boolan} clip 結合範囲をグリッドの現在のビュー範囲にクリップするかどうか
   * @return {*} 結合範囲を指定するCellRange
   */
  mergedRange = (wjgGrid, panel, r, c, clip = true) => {
    let rng = new wjgGrid.CellRange(r, c);

    if (panel.cellType == CellType.ColumnHeader) {
      if (r == 0) {
        rng.col = c - (c % 3);
        rng.col2 = rng.col + 2;
        return rng;
      }
      if ((r == 0 ||r == 1 )&& ['chousaYear', 'zigyoujo', 'chousaCompany'].includes(panel.columns.at(c).binding)) {
        rng.col = 1;
        rng.col2 = 1;
        return rng;
      }
    }

    if (panel.cellType == CellType.Cell) {
      if (c < 4) {
        let pcol = c > 0 ? c - 1 : c;
        let pval = panel.getCellData(r, pcol, false);
        let val = panel.getCellData(r, c, false);

        // 縦結合（up）※現行と前行の列が一致
        while (rng.row > 0 &&
          panel.getCellData(rng.row - 1, c, false) == val &&
          panel.getCellData(rng.row - 1, pcol, false) == pval) {
          rng.row--;
        }
        // 縦結合（down）※現行と前行のが一致
        while (rng.row2 < panel.rows.length - 1 &&
          panel.getCellData(rng.row2 + 1, c, false) == val &&
          panel.getCellData(rng.row2 + 1, pcol, false) == pval) {
          rng.row2++;
        }
      }
      // else {
      //   const data = panel.rows[r].dataItem;
      //   if (data.yearMerge) {
      //     rng.col = c - (c % 3);
      //     rng.col2 = rng.col + 2;
      //   }
      // }
    }
    return rng;
  };
  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: false,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'None',
      // counterOn: false,
      // AddDeleteOn: false,
      style: {height: 'auto', maxHeight: '550px'},
      isReadOnly: true,
      isDisplayCount: true,
      // customMergedRange: this.mergedRange,
      checkedFunction: this.checkStateUpdate,
    };
    // return (
    //   <CustomFlexGrid ref={this.gridRef} {...props}>
    //     {populationViews}
    //   </CustomFlexGrid>
    // );
    // 一覧定義取得
    let viewElems = [];
    if (populationViews) {
      for (const view of populationViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              // viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          // viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }


    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={this.doPrint}
            variant="contained"
            startIcon={<GetAppIcon />}
            // size="large"
          >
            <span>調査口数一覧出力</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };
  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYearSearch" item xs={12} sm={1}>
            <Field
              id="surveyYearSearch"
              name="surveyYearSearch"
              component={renderSelect}
              className="fields"
              label="年度"
              fullWidth
              type="text"
              required={true}
              validate={[
              ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tdhknAddCdSearch" item xs={12} sm={2}>
            <Field
              id="tdhknAddCdSearch"
              name="tdhknAddCdSearch"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="都道府県"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={2000}>{'鳥取県'}</MenuItem>
              <MenuItem value={3000}>{'島根県'}</MenuItem>
              <MenuItem value={4000}>{'岡山県'}</MenuItem>
              <MenuItem value={5000}>{'広島県'}</MenuItem>
              <MenuItem value={6000}>{'山口県'}</MenuItem>
            </Field>
          </Grid>

          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              type="text"
              label="NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={3100}>{'山陰'}</MenuItem>
              <MenuItem value={3110}>{'出雲'}</MenuItem>
              <MenuItem value={3120}>{'浜田'}</MenuItem>
              <MenuItem value={3130}>{'隠岐'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujoOld" item xs={12} sm={2}>
            <Field
              id="zigyoujoOld"
              name="zigyoujoOld"
              // variant="standard"
              component={renderSelect}
              className="fields"
              type="text"
              label="旧NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5160}>{'広島北'}</MenuItem>
              <MenuItem value={6120}>{'廿日市'}</MenuItem>
            </Field>
          </Grid>
          {/* <Grid key="chousaKaisha" item xs={12} sm={2}>
            <Field
              id="chousaKaisha"
              name="chousaKaisha"
              component={renderSelect}
              className="fields"
              type="text"
              label="委託エリア"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={0}>{'中電'}</MenuItem>
              <MenuItem value={1}>{'委託１'}</MenuItem>
              <MenuItem value={2}>{'委託２'}</MenuItem>
              <MenuItem value={3}>{'委託３'}</MenuItem>
            </Field>
          </Grid> */}
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    // const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          // footerBtn={footerBtn}
        >
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCC1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>

            <Grid
              container
              justifyContent="right"
              alignItems="right"
              spacing={1}
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className={classes.button}
                  // size="large"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className={clsx(classes.button)}
                  // size="large"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="key1001List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: {
      surveyYearSearch: '2',
      // tdhknAddCdSearch: '3000',
    },
    // initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
